import { jsxs, jsx } from "react/jsx-runtime";
const ReturnWidget = ({ data }) => {
  const { orderId, steps, currentStepIndex } = data;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        width: "100%",
        maxWidth: 400,
        background: "var(--voice-widget-card-bg, #FFFFFF)",
        border: "1px solid var(--voice-widget-border, #E5E7EB)",
        borderRadius: 16,
        padding: "18px 18px 14px",
        boxSizing: "border-box",
        boxShadow: "0 2px 12px rgba(0,0,0,0.07)"
      },
      children: [
        /* @__PURE__ */ jsxs("div", { style: { marginBottom: 16 }, children: [
          /* @__PURE__ */ jsxs(
            "div",
            {
              style: {
                fontSize: 11,
                fontWeight: 700,
                letterSpacing: 0.5,
                textTransform: "uppercase",
                color: "var(--voice-widget-muted, #6B7280)",
                marginBottom: 2
              },
              children: [
                "Return — Order #",
                orderId
              ]
            }
          ),
          /* @__PURE__ */ jsxs("div", { style: { fontSize: 14, fontWeight: 600, color: "var(--voice-widget-fg, #111827)" }, children: [
            "Step ",
            currentStepIndex + 1,
            " of ",
            steps.length
          ] })
        ] }),
        /* @__PURE__ */ jsx("div", { style: { display: "flex", flexDirection: "column", gap: 0 }, children: steps.map((step, i) => {
          const done = i < currentStepIndex;
          const active = i === currentStepIndex;
          const upcoming = i > currentStepIndex;
          return /* @__PURE__ */ jsxs(
            "div",
            {
              style: { display: "flex", gap: 12, position: "relative" },
              children: [
                /* @__PURE__ */ jsxs("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", width: 24, flexShrink: 0 }, children: [
                  /* @__PURE__ */ jsxs(
                    "div",
                    {
                      style: {
                        width: 22,
                        height: 22,
                        borderRadius: "50%",
                        background: done ? "var(--voice-widget-accent, #7DD3C0)" : active ? "var(--voice-widget-accent, #7DD3C0)" : "var(--voice-widget-border, #E5E7EB)",
                        border: active ? "3px solid var(--voice-widget-accent, #7DD3C0)" : "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        boxSizing: "border-box",
                        zIndex: 1
                      },
                      children: [
                        done && /* @__PURE__ */ jsx("svg", { width: "11", height: "9", viewBox: "0 0 11 9", fill: "none", children: /* @__PURE__ */ jsx("path", { d: "M1 4l3 3 6-6", stroke: "white", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round" }) }),
                        active && /* @__PURE__ */ jsx("div", { style: { width: 8, height: 8, borderRadius: "50%", background: "white" } })
                      ]
                    }
                  ),
                  i < steps.length - 1 && /* @__PURE__ */ jsx(
                    "div",
                    {
                      style: {
                        width: 2,
                        flex: 1,
                        minHeight: 20,
                        background: i < currentStepIndex ? "var(--voice-widget-accent, #7DD3C0)" : "var(--voice-widget-border, #E5E7EB)",
                        margin: "2px 0"
                      }
                    }
                  )
                ] }),
                /* @__PURE__ */ jsxs(
                  "div",
                  {
                    style: {
                      paddingBottom: i < steps.length - 1 ? 16 : 0,
                      flex: 1,
                      paddingTop: 1
                    },
                    children: [
                      /* @__PURE__ */ jsx(
                        "div",
                        {
                          style: {
                            fontSize: 13,
                            fontWeight: active ? 700 : done ? 500 : 400,
                            color: upcoming ? "var(--voice-widget-muted, #6B7280)" : "var(--voice-widget-fg, #111827)",
                            marginBottom: step.description && active ? 3 : 0
                          },
                          children: step.label
                        }
                      ),
                      active && step.description && /* @__PURE__ */ jsx(
                        "div",
                        {
                          style: {
                            fontSize: 12,
                            color: "var(--voice-widget-muted, #6B7280)",
                            lineHeight: 1.4
                          },
                          children: step.description
                        }
                      )
                    ]
                  }
                )
              ]
            },
            i
          );
        }) })
      ]
    }
  );
};
export {
  ReturnWidget
};
//# sourceMappingURL=ReturnWidget.js.map
